import MarkdownPage from "@/lib/components/MarkdownPage";

const markdownData = `
# Informasjonskapsler på Eventlista

Eventlista sporer ikke dine bevegelser og bruker ikke tjenester fra tredjepart. Altså ingen lugubre informasjonskapsler ( « cookies » ) som krenker ditt personvern.

Når du logger inn, vil enheten din lagre en hemmelighet. Denne er påkrevd for å holde deg innlogget, og kan ikke leses av tredjeparts-aktører.

*Sist oppdatert: 26. juli 2024*
`

export default function Index() {
    return (
        <MarkdownPage markdown={markdownData}/>
    )
}